// src/functions/lang.js
// Fonction utilitaire pour récupérer le label selon la langue
export function getLabel(obj, language) {
    if (!obj) return '';
    const map = {
        french: obj.label_fr ?? obj.unitlabel_fr ?? '',
        english: obj.label_en ?? obj.unitlabel_en ?? '',
        portuguais: obj.label_pr ?? obj.unitlabel_pr ?? '',
        swahili: obj.label_sw ?? obj.unitlabel_sw ?? '',
    };
    return map[language] ?? '';
}

